import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const QRCodePreview = ({ 
  qrCodeUrl, 
  restaurantName, 
  restaurantLogo,
  restaurantLogoAlt,
  size = 'large',
  showBorder = true,
  includeLogo = true
}) => {
  const sizeClasses = {
    small: 'w-32 h-32 md:w-40 md:h-40',
    medium: 'w-48 h-48 md:w-56 md:h-56',
    large: 'w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96'
  };

  return (
    <div className="qr-preview-container bg-card rounded-xl p-6 md:p-8 lg:p-10 shadow-warm-lg transition-smooth">
      <div className="qr-preview-header mb-6 md:mb-8">
        <div className="flex items-center justify-center space-x-3 mb-4">
          {includeLogo && restaurantLogo && (
            <Image
              src={restaurantLogo}
              alt={restaurantLogoAlt}
              className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg object-cover shadow-warm"
            />
          )}
          <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground text-center">
            {restaurantName}
          </h3>
        </div>
        <p className="text-sm md:text-base text-muted-foreground text-center font-caption">
Scannez pour voir votre menu numérique
        </p>
      </div>
      <div className="qr-preview-code flex items-center justify-center mb-6">
        <div className={`qr-code-wrapper ${showBorder ? 'border-4 border-primary/20 rounded-2xl p-4 md:p-6' : ''} bg-background transition-smooth`}>
          <div className={`${sizeClasses?.[size]} relative`}>
            {qrCodeUrl ? (
              <Image
                src={qrCodeUrl}
                alt={`QR code for ${restaurantName} digital menu - scan with smartphone camera to access menu`}
                className="w-full h-full object-contain"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-muted rounded-lg">
                <div className="text-center">
                  <Icon name="QrCode" size={48} className="mx-auto mb-3 text-muted-foreground" />
                  <p className="text-sm text-muted-foreground font-caption">
                    QR Code Preview
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="qr-preview-footer text-center">
        <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full">
          <Icon name="Scan" size={16} />
          <span className="text-xs md:text-sm font-caption font-medium">
            Camera Ready
          </span>
        </div>
      </div>
    </div>
  );
};

export default QRCodePreview;